export default "/videos/079ceb7be552d0917922d9a2e2c5e7d0.mp4";